var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinUnactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 72,
    viewBox: "0 0 68 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3859_67235)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 6,
    width: 44,
    height: 44,
    rx: 22,
    fill: "#ECD06C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 7,
    width: 42,
    height: 42,
    rx: 21,
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2093 52.9824C33.6097 53.4981 34.3888 53.4981 34.7892 52.9824L37.4634 49.5374H30.5352L33.2093 52.9824Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9592 21.8668L29.2676 20.0418C27.2759 19.0668 25.6426 20.0585 25.6426 22.2418L25.6426 34.6085C25.6426 35.5585 26.4342 36.3335 27.4009 36.3335H33.5842C34.0426 36.3335 34.4176 35.9585 34.4176 35.5001V24.1751C34.4176 23.3001 33.7592 22.2585 32.9592 21.8668ZM31.4759 29.4585H28.5842C28.2426 29.4585 27.9592 29.1751 27.9592 28.8335C27.9592 28.4918 28.2426 28.2085 28.5842 28.2085H31.4759C31.8176 28.2085 32.1009 28.4918 32.1009 28.8335C32.1009 29.1751 31.8259 29.4585 31.4759 29.4585ZM31.4759 26.1251H28.5842C28.2426 26.1251 27.9592 25.8418 27.9592 25.5001C27.9592 25.1585 28.2426 24.8751 28.5842 24.8751H31.4759C31.8176 24.8751 32.1009 25.1585 32.1009 25.5001C32.1009 25.8418 31.8259 26.1251 31.4759 26.1251Z",
    fill: "#0B0C0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3327 33.0332V34.2499C42.3327 35.3999 41.3993 36.3332 40.2493 36.3332H36.4743C36.0243 36.3332 35.666 35.9749 35.666 35.5249V33.7249C36.5577 33.8332 37.4993 33.5749 38.1743 33.0332C38.741 33.4915 39.466 33.7665 40.2577 33.7665C41.0327 33.7665 41.7577 33.4915 42.3327 33.0332Z",
    fill: "#0B0C0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3327 30.5418V30.5501C42.266 31.6418 41.3743 32.5168 40.2577 32.5168C39.0993 32.5168 38.1743 31.5751 38.1743 30.4334C38.1743 31.7084 36.9993 32.7334 35.666 32.4751V28.0001C35.666 27.4668 36.1577 27.0668 36.6827 27.1834L38.1743 27.5168L38.5743 27.6084L40.2743 27.9918C40.6827 28.0751 41.0577 28.2168 41.3827 28.4251C41.3827 28.4334 41.391 28.4334 41.391 28.4334C41.4743 28.4918 41.5577 28.5584 41.6327 28.6334C42.016 29.0168 42.266 29.5751 42.3243 30.3918C42.3243 30.4418 42.3327 30.4918 42.3327 30.5418Z",
    fill: "#0B0C0E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3859_67235",
    x: 0,
    y: 0,
    width: 68,
    height: 71.3691,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3859_67235"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3859_67235",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinUnactive);
export default __webpack_public_path__ + "static/media/Pin_unactive.8bb8397289956e5198a59bc2b0d5d7fa.svg";
export { ForwardRef as ReactComponent };